import Vue from 'vue'

const setCurrentLegend = (state, payload) => {
  state.currentLegend = payload
}
const setAllLegend = (state, payload) => {
  state.allLegend = payload
}
const IncrementLegend = (state, payload) => {
  if (!state.allLegend.includes(payload)) {
    state.allLegend.push(payload)
  }
}
const UpdateLegend = (state, payload) => {
  if (payload === undefined || payload === null || payload.layerId === undefined) return
  const index = state.allLegend.findIndex(x => x !== undefined && x.layerId === payload.layerId)
  if (index === -1) {
    state.allLegend.push(payload)
  } else {
    Vue.set(state.allLegend, index, payload)
  }
}
const DecrementLegend = (state, payload) => {
  state.allLegend = state.allLegend.filter((legend) => {
    if (legend !== undefined && legend.layerId !== payload) return legend
  })
}
const setEditLegend = (state, payload) => {
  state.editLegend = payload
}
const setLoadingLegend = (state, payload) => {
  state.loadingLegend = payload
}

export default {
  setLoadingLegend,
  setCurrentLegend,
  setAllLegend,
  IncrementLegend,
  UpdateLegend,
  DecrementLegend,
  setEditLegend
}
